import React from 'react';
import { Navigate } from 'react-router';
import { Capacitor } from '@capacitor/core';

const PASSWORD_AUTH_KEY = 'site_password_authenticated';

// Check if we're in production (virtoly.com, not staging.virtoly.com, or native mobile app)
function isProduction(): boolean {
    // Native mobile apps (Android/iOS) are always considered production
    if (Capacitor.isNativePlatform()) {
        return true;
    }
    
    const hostname = window.location.hostname;
    // Production is virtoly.com (without staging prefix)
    // Staging is staging.virtoly.com
    return hostname === 'virtoly.com' || hostname === 'www.virtoly.com';
}

export function isPasswordAuthenticated(): boolean {
    // In production, always authenticated (no password gate)
    if (isProduction()) {
        return true;
    }
    
    // Skip password gate for local development
    if (window.location.hostname === 'localhost') {
        return true;
    }
    
    return localStorage.getItem(PASSWORD_AUTH_KEY) === 'true';
}

export function setPasswordAuthenticated(value: boolean): void {
    if (value) {
        localStorage.setItem(PASSWORD_AUTH_KEY, 'true');
    } else {
        localStorage.removeItem(PASSWORD_AUTH_KEY);
    }
}

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    if (!isPasswordAuthenticated()) {
        return <Navigate to="/password" replace />;
    }

    return <>{children}</>;
}


